import React from 'react';

const FceContracts = () => {};

export default FceContracts;
